export default __webpack_public_path__ + "static/waqas_rana-0c7ebaa4ac655a67ec702570602e6bb8.jpg";